import axios from "axios";
import { EXTERNAL_LOGIN_URL } from "../consts";
import { getIsIpDomain } from "./_getIsIpDomain";

const getStoredToken = () => localStorage.getItem("token") || null;

const remote = true;

const apiDomain = remote
  ? "https://plataforma.lex.com.br"
  : "http://localhost:3001";

export const apiInstancePublic = axios.create({
  baseURL: `${apiDomain}/api/lex/produto/v1/`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const apiInstance = axios.create({
  baseURL: `${apiDomain}/api/lex/produto/v1/`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

apiInstance.interceptors.request.use(
  (config) => {
    const token = getStoredToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;

      const isIpDomain = getIsIpDomain();

      if (status === 401) {
        localStorage.removeItem("token");

        if (!isIpDomain) {
          window.location.href = EXTERNAL_LOGIN_URL;
        } else {
          if (window.location.pathname !== "/login") {
            window.location.href = "/login";
          }
        }
      }

      if (status >= 500) {
        console.error("Erro no servidor:", error.response.data);
      }
    } else if (error.code === "ECONNABORTED") {
      console.error("Tempo limite da requisição excedido.");
    }

    return Promise.reject(error);
  },
);
